import { createFileRoute } from "@tanstack/react-router"

import { TalentProgressDashboard } from "@/components/talent-tracking/TalentProgressDashboard"

export const Route = createFileRoute("/_authed/boss-talents")({
  component: TalentProgressDashboard,
})
